// ---------------------------------------------------------------
// useSectionContext.js — Canal ligero para que cada sección publique
// una línea de contexto que se muestra bajo el título de la barra
// superior (p. ej. "agosto · 138 h · 3 guardias").
//
// Es un contexto de React con un solo string: no añade consultas ni
// listeners, y se limpia solo al salir de la sección.
// ---------------------------------------------------------------
import { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext({ text: "", setText: () => {} });

export function SectionContextProvider({ children }) {
  const [text, setText] = useState("");
  return <Ctx.Provider value={{ text, setText }}>{children}</Ctx.Provider>;
}

/** Lee el contexto actual (lo usa la barra superior) */
export function useSectionContextValue() {
  return useContext(Ctx).text;
}

/** Publica el contexto de la sección activa */
export function useSectionContext(text) {
  const { setText } = useContext(Ctx);
  useEffect(() => {
    setText(text || "");
    return () => setText("");
  }, [text, setText]);
}
